<template>
  <v-container>
    <v-form ref="form" lazy-validation @submit.prevent="submit">
      <v-row>
        <v-col cols="12" sm="6">
          <v-text-field
            v-model="config.name"
            label="Navn"
            hint="Internt navn, f.eks 'Vipps produksjonsnøkler'"
            :rules="[rules.required]"
            :disabled="isSaving || isLoading"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            v-model="config.frontend_label"
            label="Butikknavn"
            hint="Vises til kunden i kassen, f.eks 'Betal med Vipps'"
            :rules="[rules.required]"
            :disabled="isSaving || isLoading"
            required
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6">
          <v-text-field
            v-model="config.client_id"
            label="Vipps Client Id"
            :rules="[rules.required]"
            :disabled="isSaving || isLoading"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            v-model="config.client_secret"
            label="Vipps Client Secret"
            :rules="[rules.required]"
            :disabled="isSaving || isLoading"
            required
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6">
          <v-text-field
            v-model="config.subscription_key"
            label="Vipps Subscription Key"
            :rules="[rules.required]"
            :disabled="isSaving || isLoading"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            v-model="config.merchant_serial_number"
            label="Vipps Merchant Serial Number"
            :rules="[rules.required]"
            :disabled="isSaving || isLoading"
            required
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6">
          <v-text-field
            v-model="config.endpoint"
            label="Vipps Endpoint"
            required
            :rules="[rules.required]"
            :disabled="isSaving || isLoading"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6">
          <v-btn
            type="submit"
            :disabled="isSaving || isLoading"
            :loading="isSaving"
            color="success"
          >
            <v-icon left> mdi-content-save </v-icon>
            Lagre
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import backend from "@/backend";

export default {
  name: "VippsConfiguration",

  props: {
    organizationId: {
      type: Number,
      required: true,
    },
  },

  data: function () {
    return {
      isLoading: true,
      isSaving: false,
      rules: {
        required: (v) => !!v || "Dette feltet er påkrevd.",
      },
      config: {
        organization: this.organizationId,
        id: null,
        name: "",
        frontend_label: "",
        client_id: "",
        client_secret: "",
        subscription_key: "",
        merchant_serial_number: "",
        endpoint: "",
      },
    };
  },

  async created() {
    const config = await backend.get("vippsconfigurations/", {
      organization: this.organizationId,
    });

    if (config.length == 1) {
      this.config = config[0];
    }

    this.isLoading = false;
  },

  methods: {
    async submit() {
      if (this.$refs.form.validate()) {
        this.isSaving = true;

        if (this.config.id) {
          this.config = await backend.put(
            `vippsconfigurations/${this.config.id}/`,
            this.config,
            {
              organization: this.organizationId,
            }
          );
        } else {
          this.config = await backend.post(
            `vippsconfigurations/`,
            this.config,
            {
              organization: this.organizationId,
            }
          );
        }

        this.$store.dispatch("add", {
          type: "success",
          message: "Vipps konfigurasjon er nå lagret.",
        });

        this.isSaving = false;
      }
    },
  },
};
</script>
